import { render, staticRenderFns } from "./copyList.vue?vue&type=template&id=41eabbf8&scoped=true&"
import script from "./copyList.vue?vue&type=script&lang=ts&"
export * from "./copyList.vue?vue&type=script&lang=ts&"
import style0 from "./copyList.vue?vue&type=style&index=0&id=41eabbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eabbf8",
  null
  
)

export default component.exports